import { Dialog } from '@components/dialog';
import type { PolicyGetResponse } from '@lio/api-types';
import { PolicyTransaction } from '@models/policyTransaction';
import { Grid } from '@mui/material';
import { Field } from '@pages/NewQuote/scope/Field';
import { getFormattedPolicyNumber } from '@utils/policy/getFormattedPolicyNumber';

export type BrokerReassignedDialogProps = {
  handleCloseDialog: () => void;
  selectedTransaction: PolicyTransaction;
  policy: PolicyGetResponse;
};

export const BrokerReassignedDialog = ({
  policy,
  handleCloseDialog,
  selectedTransaction,
}: BrokerReassignedDialogProps) => {
  const trx = selectedTransaction?.policyBrokerReassignmentTransaction as any; // as any due to API type being 'null or undefined'

  const previousName = `${trx?.previousBrokerageProducer?.user?.firstName} ${trx?.previousBrokerageProducer?.user?.lastName}`;
  const newName = `${trx?.newBrokerageProducer?.user?.firstName} ${trx?.newBrokerageProducer?.user?.lastName}`;
  const reason = selectedTransaction?.description;

  const formattedPolicyNumber = getFormattedPolicyNumber(policy.policyNumberPrefix, policy.policyNumber.policyNumber);

  return (
    <Dialog
      open
      secondaryBtnAction={handleCloseDialog}
      handleCloseDialog={handleCloseDialog}
      title={`Producer Reassigned on ${formattedPolicyNumber}`}
      primaryBtnText={undefined}
      secondaryBtnText='Exit'
    >
      <Grid sx={{ padding: '16px 24px', display: 'flex', flexDirection: 'column' }} gap={2}>
        {[
          { label: 'Previous Producer', value: previousName },
          { label: 'New Producer', value: newName },
          { label: 'Reason', value: reason, labelSx: { fontWeight: 'normal' } },
        ]
          ?.filter((t) => !!t.value)
          .map((field) => (
            <Field
              key={field.label}
              value={field.label}
              label={field.value ?? ''}
              sxProps={{ box: { gap: 1, display: 'flex' }, label: field.labelSx ?? {} }}
            />
          ))}
      </Grid>
    </Dialog>
  );
};
